
import { Faq } from "../APIs/faq";

//
export interface BlogState {
  id?: number;
  title: string;
  meta_title: string;
  meta_description: string;
  blogText: string;
  link: string;
  image: string;
}

export interface Blog {
  id: number;
  title: string;
  meta_title: string;
  meta_description: string;
  blogText: string;
  image: string;
  name: string;
  link: string;
}


export interface StockResponse {
  warehouse: string;
  itemCode: number;
  principle: string;
  quantity: number;
}

export interface ISection {
  sections: ISection[];
  answer: string;
  question: string;
  title: string;
  content: any;
  image?: any;
  faqs?: Faq[];
}

export interface IComment {
  name: string;
  isVerified: boolean;
  rating: number;
  date: string;
  message: string;
  numLikes: number;
  numDislikes: number;
}

export interface User {
  email: string;
  role: string;
  firstName: string;
  password: string;
  lastName: string;
  createAt: string;
}

export interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  password: string;
  id?: number;
}

export interface BlogState {
  bloglink: string;
  id?: number;
  title: string;
  blogText: string;
  link: string;
  image: string;
}

export interface FormComponentProps {
  formData: FormData;
  onSubmit: (data: FormData) => void;
  isUpdate?: boolean;
  isUpdateDelete?: boolean;
  onDelete?: () => void;
  onClick?: (e: any) => void;
}

export interface Product {
  id: number;
  banner: string | null;
  name: string;
  meta_title: string;
  meta_description: string;
  description: string;
  caption: string;
  ingredient: string;
  price: number;
  rating: number;
  image: string | null;
  category: string;
  productlinkname: string;
  productaltbanner?: string;
  watermachineid?: number | null;
  product_type?: string;
}

export interface WaterMachine {
  id?: number;
  name: string | any;
  description: string;
  images_white: string[];
  images_black: string[];
  video: string | null;
  newMethod?: string;
  meta_description: string;
  meta_title: string;
  machinelink?: any;
  productName?: string;
  height?: string;
  price: string;
  width?: string;
  sku: string;
  length?: string;
  weight?: string;
  is_new?: boolean;
  mini_description?: string;
}

export interface FormComponentProps {
  formData: FormData;
  newImage?: string;
  onSubmit: (data: FormData) => void;
  isUpdate?: boolean;
  onClick?: (e: any) => void;
  onDelete?: () => void;
}

export interface AccessProduct {
  id?: number;
  name: string;
  description: string;
  caption: string;
  image: File | string;
}

export interface Store {
  id?: number;
  name: string;
  description: string;
  caption: string;
  image: File | string;
}

export interface AccessFormData {
  id?: number;
  name: string;
  description: string;
  caption: string;
  image: File | string;
}

export interface FormComponentProps {
  formData: FormData;
  onSubmit: (data: FormData) => void;
  isUpdate?: boolean;
  onClick?: (e: any) => void;
  isUpdateDelete?: boolean;
  onDelete?: () => void;
}

export interface AccessoryData {
  id?: number;
  name: string;
  description: string;
  meta_title: string;
  meta_description: string;
  caption: string;
  image: string;
  accessorylink: string;
  price?: string;
  sku?: string;
  height?: string;
  width?: string;
  length?: string;
  weight?: string;
  is_coming_soon ?: boolean;
}

export const labelStyle: LabelStyle = {
  color: "#005D6E",
  fontFamily: "",
  fontSize: "16px",
  fontStyle: "normal",

  lineHeight: "normal",
  textAlign: "start",

  marginLeft: "0px",
  marginBottom: "8px",
};

export interface LabelStyle {
  color: string;
  fontFamily: string;
  fontSize: string;
  fontStyle: string;

  lineHeight: string;
  textAlign: string;

  marginLeft: string;
  marginBottom: string;
}

export interface AccessData {
  id?: number;
  banner: string;
  name: string;
  description: string;
  caption: string;
  ingredient: string;
  price: number;
  rating: number;
  image: string;
}

export interface AccessProps {
  formData: AccessProps;
  onSubmit: (data: AccessProps) => void;
  isUpdate?: boolean;
  onDelete?: () => void;
  id?: number;
  name: string;
  description: string;
  caption: string;
  image: string | null;
  price?: string;
  sku?: string;
}

export interface Mixology {
  id?: number;
  name: string;
  ingredients: string[];
  methods: string[];
  description: string;
  meta_title: string;
  meta_description: string;
  productId?: number | null | undefined;
  image: string | null;
  width?: string;
  recipelink: string;
}

export interface ProductsFlavours {
  id: number;
  banner: string;
  name: string;
  description: string;
  caption: string;
  ingredient: string;
  price: number;
  rating: string | number;
  image: string;
  category: string;
  cta?: string;
  productlinkname: string;
  productaltbanner: string;
  product_type: string;
  order_type?: string;
  quantity?: number;
}

export const defaultProduct: ProductsFlavours = {
  id: 0,
  banner: "default banner",
  name: "default name",
  description: "default description",
  caption: "default caption",
  ingredient: "default ingredient",
  price: 0,
  rating: "default rating",
  image: "default image",
  category: "default category",
  productlinkname: "default link",
  productaltbanner: "n",
  product_type: "",
  order_type: "",
  quantity: 1,
};

export interface Mixologies {
  id?: number;
  name: string;
  ingredients: string[];
  methods: string[];
  description: string;
  productId?: number;
  image: string;
  meta_title: string;
  meta_description: string;
  recipelink: string;
}

export const defaultRec: Mixologies = {
  name: "default name",
  ingredients: ["default ingredient...."],
  methods: ["default methods......."],
  description: "default description",
  image: "default image",
  productId: 0,
  meta_title: "default meta_title",
  meta_description: "default meta_description",
  recipelink: "n",
};

export interface DataRecipe {
  name: string | any;
  ingredients: string[];
  methods: string[];
  image: string | null;
  description: string;
  productId?: number | undefined;
  newMethod: string;
  newIngredient: string;
  meta_description: string;
  meta_title: string;
  recipelink: string;
}

export interface Access {
  id?: number;
  name: string;
  description: string;
  caption: string;
  image: string;
}

export interface StoreDateType {
  id?: number;
  storeName: string;
  storeId: string;
  storeNo: string;
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  phoneNo: number;
  status: string;
  lat: number;
  lng: string;
  addressType: string;
  locationType: string;
  sell_machine: boolean;
  cylinder_exchange: boolean;
  meta_title: string;
  meta_description: string;
}

export interface Recipe {
  id?: number;
  name: string;
  ingredients: string[];
  methods: string[];
  image: string | null;
  description: string;
  productId: number | undefined;
  newMethod: string;
  newIngredient: string;
  meta_description: string;
  meta_title: string;
  recipelink: string;
}

export interface StoreData {
  id?: number;
  storeName: string;
  storeId: string;
  storeNo: string;
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  phoneNo: number;
  status: string;
  lat: number;
  lng: string;
  addressType: string;
  locationType: string;
  sell_machine: boolean;
  cylinder_exchange: boolean;
  meta_description: string;
  meta_title: string;
}

export interface AccessRecipe {
  formData: DataRecipe;
  onSubmit: (data: DataRecipe) => void;
  isUpdate?: boolean;
  onDelete?: () => void;
  id?: number;
  productId?: number;
  onClick?: (e: any) => void;
  isUpdateDelete?: boolean;
}

export interface StockResponseContext {
  warehouse: string;
  itemCode: number;
  principle: string;
  quantity: number;
}

export interface ProductContext {
  id: number;
  banner: string;
  name: string;
  description: string;
  caption: string;
  ingredient: string;
  price: number;
  rating: string | number;
  image: string;
  category: string;
  cta?: string;
  productlinkname: string;
  productaltbanner: string;
  product_type: string;
  order_type?: string;
  height: string;
  width: string;
  weight: string;
  length: string;
  color?: string;
  sku?: string;
  item_quantity?: number;
  is_black?: boolean;
  is_machine?: boolean;
}

export interface CartItemContext extends ProductContext {
  item_quantity: number;
  original_price: number;
  availableStock?: number;
  principle?: string;
  quantity: number;
  is_machine: boolean;
  is_black: boolean;
}

export interface WmsOrderDataContext {
  OrderNumber: string;
  orderDate: string;
  customerName: string;
  companyName: string;
  contactNumber: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  city: string;
  postalCode: string;
  itemCode: string;
  warehouse: string;
  description: string;
  principle: string;
  quantity: number;
  status: string;
}

export interface CartContextProps {
  getItemFromDB: (order_reference: string) => void;
  cart: CartItemContext[];
  isUpdating: boolean;
  isDecreasing: boolean;
  orderReference: string | null;
  principle: string | null;
  setPrinciple: (principle: string) => void;
  availableStock: number | null;
  setAvailableStock: (availableStock: number) => void;
  itemStocks: Record<string, number>;
  itemPrincipales: Record<string, string>;
  addToCart: (product: ProductContext, quantity: number) => void;
  removeFromCart: (product: ProductContext) => void;
  clearCart: () => Promise<void>;
  getItemStock: (sku: string) => void;
  quantity: number | null;
  checkStockAvaibility: (sku: string) => void;
  checkStockQuantity: number | null;
  fetchStockForAllItems: () => void;
  handleDecrease: (product: ProductContext) => void;
  handleIncrease: (product: ProductContext) => void;
  setCart: React.Dispatch<React.SetStateAction<CartItemContext[]>>;
  isRemoving: boolean;
}
